import api from "./index";

export interface TestPassListParams {
  ownerId?: string;
  testId?: string;
  targetType?: string;
  targetId?: string;
  testeeType?: string;
  testeeId?: string;
  startedAtMin?: Date;
  startedAtMax?: Date;
  finishedAtMin?: Date;
  finishedAtMax?: Date;
  passedAtMin?: Date;
  passedAtMax?: Date;
  passed?: boolean;
  success?: boolean;
  limit?: number;
  offset?: number;
  options?: any;
}

export default (params: TestPassListParams, options?: any) => {
  return api.TestPassApi.list(
    params.ownerId,
    params.testId,
    params.targetType,
    params.targetId,
    params.testeeType,
    params.testeeId,
    params.startedAtMin,
    params.startedAtMax,
    params.finishedAtMin,
    params.finishedAtMax,
    params.passedAtMin,
    params.passedAtMax,
    params.passed,
    params.success,
    params.limit,
    params.offset,
    options
  );
};
